module.exports = __webpack_public_path__ + "static/img/2.37ca369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colectivo-de-vida/2.png
// module id = 0YcK
// module chunks = 0